// extracted by mini-css-extract-plugin
var _1 = "ThreadVersionChangeCard-module__animateUploadProgressBarWidth--GE233";
var _2 = "ThreadVersionChangeCard-module__animatedBackground--o4pf_";
var _3 = "ThreadVersionChangeCard-module__content--ibqEd";
var _4 = "ThreadVersionChangeCard-module__focused--hpbBa";
var _5 = "ThreadVersionChangeCard-module__footer--FkXls";
var _6 = "ThreadVersionChangeCard-module__newCommentsText--xGli4";
var _7 = "ThreadVersionChangeCard-module__resolved--WLfGv";
var _8 = "ThreadVersionChangeCard-module__resolvedThreadText--JPiQk";
var _9 = "ThreadVersionChangeCard-module__resolvedThreadTextContainer--CO5aB";
var _a = "ThreadVersionChangeCard-module__unresolveButton--Y6nnK";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "content", _4 as "focused", _5 as "footer", _6 as "newCommentsText", _7 as "resolved", _8 as "resolvedThreadText", _9 as "resolvedThreadTextContainer", _a as "unresolveButton" }
